<template>
  <div>
    <label class="d-block font-size-14 mb-1"><strong>{{ label }}</strong></label>
    <a :href="value"
      rel="”noopener noreferer"
      class="hiperlink-component-link font-size-14"
      target="_blank">{{ value }}</a>
  </div>
</template>

<script>
export default {
  name: "HiperlinkComponent",

  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
  .hiperlink-component-link {
    padding: 10px 10px;
    border: solid 1px #ddd;
    background: #fafafa;
    border-radius: 4px;
    display: block;
    transition: all 0.5s;
    max-width: 100%;
    word-wrap: break-word;


    &:hover {
      background: #eee;
      border-color: #ccc;
    }
  }
</style>